export const codeSnippet = {
  code1: ``,
  code2: ``,
  code3: `import org.springframework.boot.ApplicationArguments;
import org.springframework.boot.ApplicationRunner;
import org.springframework.stereotype.Component;

@Component
public class MyApplicationRunner implements ApplicationRunner {

    @Override
    public void run(ApplicationArguments args) throws Exception {
        // Custom logic or initialization tasks to be executed after application startup
        System.out.println("ApplicationRunner is running!");
    }
}`,
  code4: `@Controller
@RequestMapping("/api")
public class MyController {

    @RequestMapping("/hello")
    public String hello() {
        return "Hello, World!";
    }

    @RequestMapping(value = "/user/{id}", method = RequestMethod.GET)
    public User getUser(@PathVariable("id") int id) {
        // Retrieve user by ID and return
    }
}`,
  code5: `@RestController
@RequestMapping("/api/users")
public class UserController {

    @GetMapping("/{id}")
    public User getUser(@PathVariable("id") int id) {
        // Retrieve user by ID and return
    }

    @PostMapping
    public User createUser(@RequestBody User user) {
        // Create a new user and return
    }

    @PutMapping("/{id}")
    public User updateUser(@PathVariable("id") int id, @RequestBody User user) {
        // Update the user with the given ID and return
    }

    @DeleteMapping("/{id}")
    public void deleteUser(@PathVariable("id") int id) {
        // Delete the user with the given ID
    }
}`,
  code6: `@GetMapping("/users/{id}")
public User getUser(@PathVariable("id") int id) {
    // Retrieve user by ID and return
}`,
  code7: `@GetMapping("/users")
public List<User> getUsers(@RequestParam("name") String name) {
    // Retrieve users by name and return
}`,
	code8: `import org.springframework.web.bind.annotation.PostMapping;
import org.springframework.web.bind.annotation.RequestParam;
import org.springframework.web.bind.annotation.RestController;
import org.springframework.web.multipart.MultipartFile;

import org.apache.commons.csv.CSVFormat;
import org.apache.commons.csv.CSVParser;
import org.apache.commons.csv.CSVRecord;

import java.io.IOException;
import java.io.InputStreamReader;
import java.io.Reader;
import java.util.Iterator;

@RestController
public class CsvController {

	@PostMapping("/upload")
	public String uploadCsv(@RequestParam("file") MultipartFile file) throws IOException {
		try (Reader reader = new InputStreamReader(file.getInputStream());
			CSVParser csvParser = new CSVParser(reader, CSVFormat.DEFAULT)) 

			int chunkSize = 1000; // Adjust the chunk size as needed
			Iterator<CSVRecord> recordIterator = csvParser.iterator();

			while (recordIterator.hasNext()) {
					processChunk(recordIterator, chunkSize);
			}
		}

		return "CSV upload and processing complete.";
	}

	private void processChunk(Iterator<CSVRecord> recordIterator, int chunkSize) {
		int count = 0;
		while (recordIterator.hasNext() && count < chunkSize) {
			CSVRecord record = recordIterator.next();
			// Process the CSV record
			System.out.println(record);
			count++;
		}
	}
}`,
	code9:`@RestController
@RequestMapping("/api")
public class DataStreamingController {

	@Autowired
	private DataService dataService;

	@GetMapping("/stream-data")
	public ResponseEntity<StreamingResponseBody> streamData() {
		StreamingResponseBody responseBody = outputStream -> {
			dataService.streamData(outputStream); // Stream the data from your service
			outputStream.flush();
		};

		return ResponseEntity.ok()
			.header(HttpHeaders.CONTENT_TYPE, MediaType.APPLICATION_JSON_VALUE)
			.body(responseBody);
	}
}`,
	code10:`@Service
public class DataService {

	public void streamData(OutputStream outputStream) {
		// Retrieve and stream your data here
		List<String> records = getDataRecords(); // Replace with your data retrieval logic

		try (BufferedWriter writer = new BufferedWriter(new OutputStreamWriter(outputStream))) {
			for (String record : records) {
				writer.write(record);
				writer.newLine();
			}
		} catch (IOException e) {
			// Handle exception
		}
	}

	private List<String> getDataRecords() {
		// Replace with your data retrieval logic
		List<String> records = new ArrayList<>();
		for (int i = 0; i < 1000; i++) {
			records.add("Record " + i);
		}
		return records;
	}
}`,
	code11:`<dependencies>
	<dependency>
		<groupId>com.fasterxml.jackson.core</groupId>
		<artifactId>jackson-databind</artifactId>
		<version>2.12.5</version>
	</dependency>
</dependencies>`,
	code12: `import com.fasterxml.jackson.annotation.JsonProperty;

public class Person {
	@JsonProperty("name")
	private String name;

	@JsonProperty("age")
	private int age;

	// Getters and setters (or use Lombok for auto-generating getters/setters)
}`,
	code13: `import com.fasterxml.jackson.databind.ObjectMapper;
import java.io.File;
import java.io.IOException;

public class JsonFileProcessing {
	public static void main(String[] args) {
		ObjectMapper objectMapper = new ObjectMapper();
		
		try {
			File jsonFile = new File("data.json"); // Replace with your JSON file path
			Person[] persons = objectMapper.readValue(jsonFile, Person[].class);
			
			for (Person person : persons) {
				System.out.println("Name: " + person.getName());
				System.out.println("Age: " + person.getAge());
				System.out.println();
			}
		} catch (IOException e) {
			e.printStackTrace();
		}
	}
}`,
	code14: `import com.fasterxml.jackson.core.JsonFactory;
import com.fasterxml.jackson.core.JsonParser;
import com.fasterxml.jackson.core.JsonToken;
import java.io.File;
import java.io.IOException;

public class LargeJsonProcessing {
	public static void main(String[] args) {
		JsonFactory jsonFactory = new JsonFactory();
		
		try {
			File jsonFile = new File("large_data.json"); // Replace with your JSON file path
			JsonParser jsonParser = jsonFactory.createParser(jsonFile);
			
			while (jsonParser.nextToken() != JsonToken.END_OBJECT) {
					String fieldName = jsonParser.getCurrentName();
					if ("name".equals(fieldName)) {
							jsonParser.nextToken();
							String name = jsonParser.getText();
							System.out.println("Name: " + name);
					} else if ("age".equals(fieldName)) {
							jsonParser.nextToken();
							int age = jsonParser.getIntValue();
							System.out.println("Age: " + age);
					}
			}
			
			jsonParser.close();
		} catch (IOException e) {
			e.printStackTrace();
		}
	}
}`,
	code15: `<!-- Maven dependency -->
<dependency>
	<groupId>org.springframework.boot</groupId>
	<artifactId>spring-boot-starter-actuator</artifactId>
</dependency>`,
	code16: `management.server.port=8081
# Enable all actuator endpoints
management.endpoints.web.exposure.include=*`,
	code17: `# Expose only specific endpoints
management.endpoints.web.exposure.include=health,metrics`,
	code18: `{
	"name": "Bob Charlie"
}`,
	code19: `{
	"name": {
		"firstName": "Bob",
		"lastName": "Charlie"
	}
}`,
	code20: `public class StudentV2 {
	private Name name;
}`,
	code21: `public class Name {
	private String firstName;
	private String lastName;
}`,
	code22: `@RestController
public class StudentVersioningController {

	@GetMapping("v1/student")
	public StudentV1 studentV1() {
		return new StudentV1("Bob Charlie");
	}

	@GetMapping("v2/student")
	public StudentV2 studentV2() {
		return new StudentV2(new Name("Bob", "Charlie"));
	}
}`,
	code23: `@RestController
@RequestMapping("/v1/api")
public class MyController {
	// Controller methods
}`,
	code24: `@GetMapping(value = "/student/param", params = "version=1")
public StudentV1 paramV1() {
	return new StudentV1("Bob Charlie");
}

@GetMapping(value = "/student/param", params = "version=2")
public StudentV2 paramV2() {
	return new StudentV2(new Name("Bob", "Charlie"));
}`,
	code25: `@RestController
@RequestMapping("/api")
public class MyController {
	@GetMapping("/resource")
	public ResponseEntity<String> getResource(@RequestParam(name = "v") int version) {
		// Controller logic
	}
}`,
	code26: `@GetMapping(value = "/student/header", headers = "X-API-VERSION=1")
public StudentV1 headerV1() {
	return new StudentV1("Bob Charlie");
}

@GetMapping(value = "/student/header", headers = "X-API-VERSION=2")
public StudentV2 headerV2() {
	return new StudentV2(new Name("Bob", "Charlie"));
}`,
	code27: `@RestController
@RequestMapping("/api")
public class MyController {
	@GetMapping("/resource")
	public ResponseEntity<String> getResource(@RequestHeader(name = "X-API-Version") int version) {
			// Controller logic
	}
}`,
	code28: `// Customer.java
@Entity
public class Customer {

	@Id
	@GeneratedValue(strategy = GenerationType.IDENTITY)
	private Long id;

	private String firstName;
	private String lastName;

	@Embedded
	private Address address;

	// Constructors, getters, and other methods
}`,
	code29: `// Address.java
@Embeddable
public class Address {

	private String street;
	private String city;
	private String zipCode;

	// Constructors, getters, and other methods

	// Implement equals and hashCode based on attributes
	// Ensure immutability by providing only getters and a constructor
}`,
	code30: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.ConditionalOnMissingBean;
import org.springframework.context.annotation.Configuration;

@Configuration
@ConditionalOnMissingBean(MyService.class)
public class MyServiceConfiguration {
		
	@Bean
	public MyService myService() {
		return new MyService();
	}
}
`,
	code31: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.ConditionalOnMissingBean;
import org.springframework.stereotype.Service;

@Service
public class MyService {
	// MyService implementation
}`,
	code32: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Configuration;

@Configuration
public class AnotherConfiguration {
		
	@Bean
	@ConditionalOnMissingBean(MyService.class)
	public AnotherService anotherService() {
		return new AnotherService();
	}
}`,
	code33: `import org.springframework.boot.autoconfigure.condition.ConditionalOnMissingClass;
import org.springframework.context.annotation.Configuration;

@Configuration
@ConditionalOnMissingClass("com.example.ExampleClass")
public class ExampleConfiguration {
	// Configuration logic
}`,
	code34: `import org.springframework.boot.autoconfigure.condition.ConditionalOnMissingClass;
import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Configuration;

@Configuration
public class AnotherConfiguration {
		
	@Bean
	@ConditionalOnMissingClass("com.example.AnotherClass")
	public AnotherService anotherService() {
		return new AnotherService();
	}
}`,
	code35: `import org.springframework.boot.autoconfigure.condition.ConditionalOnClass;
import org.springframework.context.annotation.Configuration;

@Configuration
@ConditionalOnClass(name = "com.example.ExampleClass")
public class ExampleConfiguration {
	// Configuration logic
}`,
	code36: `import org.springframework.boot.autoconfigure.condition.ConditionalOnClass;
import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Configuration;

@Configuration
public class AnotherConfiguration {
		
	@Bean
	@ConditionalOnClass(name = "com.example.AnotherClass")
	public AnotherService anotherService() {
		return new AnotherService();
	}
}`,
	code37: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Conditional;
import org.springframework.context.annotation.Configuration;

@Configuration
public class AppConfig {

	@Bean
	@Conditional(MyCondition.class)
	public MyBean myBean() {
		return new MyBean();
	}
}`,
	code38: `import org.springframework.context.annotation.Condition;
import org.springframework.context.annotation.ConditionContext;
import org.springframework.core.type.AnnotatedTypeMetadata;

public class MyCondition implements Condition {

	@Override
	public boolean matches(ConditionContext context, AnnotatedTypeMetadata metadata) {
		// Implement your condition logic here
		// For example, let's check if a system property is set
		return Boolean.parseBoolean(System.getProperty("myapp.custom.condition"));
	}
}`,
	code39: `import org.springframework.boot.autoconfigure.condition.ConditionalOnProperty;
import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Configuration;

@Configuration
public class MyConfig {

	@Bean
	@ConditionalOnProperty(name = "myapp.feature.enabled", havingValue = "true")
	public MyBean myBean() {
		return new MyBean();
	}
}`,
	code40: `myapp.feature.enabled=true`,
	code41: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Conditional;
import org.springframework.context.annotation.Configuration;

@Configuration
public class MyConfig {

	@Bean
	public DependencyBean dependencyBean() {
		return new DependencyBean();
	}

	@Bean
	@ConditionalOnBean(name = "dependencyBean")
	public MyBean myBean() {
		return new MyBean();
	}
}`,
	code42: `import org.springframework.web.bind.annotation.PostMapping;
import org.springframework.web.bind.annotation.RequestBody;
import org.springframework.web.bind.annotation.RequestMapping;
import org.springframework.web.bind.annotation.RestController;

@RestController
@RequestMapping("/example")
public class ExampleController {

	@PostMapping(value = "/process",
		consumes = "application/json",   // Specifies the expected input media type
		produces = "application/json")   // Specifies the desired output media type
	public String processRequest(@RequestBody String jsonData) {
		// Controller logic to process JSON data and generate a JSON response
		return "{\"status\":\"success\"}";
	}
}`,
	code43: `import org.springframework.context.annotation.Configuration;
import org.springframework.web.servlet.config.annotation.ContentNegotiationConfigurer;
import org.springframework.web.servlet.config.annotation.EnableWebMvc;
import org.springframework.web.servlet.config.annotation.WebMvcConfigurerAdapter;

@Configuration
@EnableWebMvc
public class WebConfig extends WebMvcConfigurerAdapter {
	@Override
	public void configureContentNegotiation(ContentNegotiationConfigurer configurer) {
		configurer.favorPathExtension(false) // Disable using file extensions to determine media types
			.favorParameter(true) // Enable using request parameters (e.g., ?format=json) to determine media types
			.parameterName("format")
			.ignoreAcceptHeader(true) // Ignore the 'Accept' header
			.useJaf(false) // Disable Java Activation Framework detection
			.defaultContentType(MediaType.APPLICATION_JSON); // Default content type
	}
}`,
	code44: `public class User {
	private String username;
	private int age;
	// Getters and setters
}`,
	code45: `import org.springframework.validation.Errors;
import org.springframework.validation.Validator;

public class UserValidator implements Validator {

	@Override
	public boolean supports(Class<?> clazz) {
		return User.class.equals(clazz);
	}

	@Override
	public void validate(Object target, Errors errors) {
		User user = (User) target;

		if (user.getAge() < 18) {
			errors.rejectValue("age", "user.age.invalid", "Age must be 18 or older");
		}

		// Add more validation rules as needed
	}
}`,
	code46: `import org.springframework.context.annotation.Bean;
import org.springframework.context.annotation.Configuration;
import org.springframework.validation.Validator;
import org.springframework.validation.beanvalidation.LocalValidatorFactoryBean;

@Configuration
public class ValidatorConfig {

	@Bean
	public Validator validator() {
		return new LocalValidatorFactoryBean();
	}

	@Bean
	public UserValidator userValidator() {
		return new UserValidator();
	}
}`,
	code47: `import org.springframework.validation.annotation.Validated;
import org.springframework.web.bind.annotation.PostMapping;
import org.springframework.web.bind.annotation.RequestBody;
import org.springframework.web.bind.annotation.RestController;

@RestController
@Validated
public class UserController {

	@PostMapping("/users")
	public String createUser(@RequestBody @Validated User user) {
		// Controller logic
		return "User created successfully";
	}
}`

}

